import { startOfDay } from "date-fns";

import proxy from "api/proxy";

let cachedLimit = null;

export async function getAccessEditLimit() {
  if (cachedLimit !== null) return cachedLimit;
  try {
    const { data } = await proxy.search(
      "staff.configuration",
      [],
      ["access_edit_limit"],
    );
    cachedLimit = Number(data?.[0]?.access_edit_limit) || 0;
  } catch (err) {
    console.error("Error fetching access_edit_limit:", err);
    return 0;
  }
  return cachedLimit;
}

function toLocalDate(timestamp) {
  if (!timestamp) return null;
  const value =
    typeof timestamp === "string" && !timestamp.endsWith("Z")
      ? `${timestamp}Z`
      : timestamp;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

export function isAccessWithinLimit(timestamp, limitDays) {
  const date = toLocalDate(timestamp);
  if (!date) return true;
  const limit = Number(limitDays) || 0;
  const today = startOfDay(new Date());
  const diffDays = Math.round(
    (today.getTime() - startOfDay(date).getTime()) / (1000 * 60 * 60 * 24),
  );
  return diffDays <= limit;
}
